module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray-7da9801891ceadf1433ecf8fb5f0aac6.png";